// Delegate — the headless hook moved to `@heidi/workspace/data` (OpenSpec
// `monorepo-workspace-data-core` · OT3, ARCFE-954). This file owns the app
// reaction (ARCFE-921): the fetch-error toast crosses the `onFetchError`
// port with the translated copy, fired at the legacy position (after the
// package hook's console.error, before its frozen null-swallow).
import { toast } from '@heidi/design-system/toast';
import { useQueryOrganizationById as useQueryOrganizationByIdCore } from '@heidi/workspace/data';

import { useTranslations } from '@heidi/runtime/i18n';

// Definition moved to `@heidi/workspace/contracts` (OT3); import + re-export
// because consumers key caches off it through this path.
import { GET_ORGANIZATION_BY_ORGANIZATION_ID } from '@heidi/workspace/contracts';

export { GET_ORGANIZATION_BY_ORGANIZATION_ID };

export function useQueryOrganizationById(
  organizationId?: string,
  isGlobalAdmin?: boolean
) {
  const { t } = useTranslations();
  return useQueryOrganizationByIdCore(organizationId, isGlobalAdmin, {
    onFetchError: () => {
      toast({
        tone: 'destructive',
        title: t('common.error'),
        description: t('organization.fetchError'),
      });
    },
  });
}
